export default __webpack_public_path__ + "static/media/click.ab8da097.svg";